import React from "react";
import abouthero from "../images/newabouthero.jpg";

function NotFound({ message }) {
  return (
    <div style={{ marginBottom: ".4rem" }}>
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          backgroundImage: `url(${abouthero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          backgroundColor: "rgb(0 0 0 / 70%)",
        }}
      >
        <div className="aboutheroreplacementbox">
          <div className="lhsheading">
            {" "}
            <span className="thick-doFt"></span>{" "}
            <span className="ps-1"> BROOKS HEALTH AND CARE </span>{" "}
          </div>
          <div className="lhssubtitle pb-2 pt-3">
            {message || "PAGE NOT FOUND"}
          </div>
        </div>
      </div>

      <div
        className="aboutsegment1  p-4 p-md-5"
        dangerouslySetInnerHTML={{ __html: "<h1><b>Error loading data.<b><h1>" }}
      ></div>
    </div>
  );
}
export default NotFound;
